import React, { useState } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "What is an Introducing Broker (IB)?",
    answer:
      "An Introducing Broker (IB) is a partner who refers clients to the platform and earns commissions based on their trading activity.",
  },
  {
    question: "What should I do if I have an issue regarding the IB program?",
    answer:
      "If you face any issues, you can contact the support team or your dedicated account manager for assistance.",
  },
  {
    question: "Can I become an IB without trading experience?",
    answer:
      "Yes, you can become an IB even without prior trading experience. Basic knowledge of financial markets can be helpful but is not mandatory.",
  },
  {
    question: "How do I register as an Introducing Broker?",
    answer:
      "You can apply through the IB registration section on the platform and complete the required details to get started.",
  },
  {
    question: "How do IBs earn commissions?",
    answer:
      "IBs earn commissions based on the trading volume or activity of the clients they refer.",
  },
  {
    question: "Is there any cost to join the IB program?",
    answer:
      "No, joining the IB program is typically free of charge.",
  },
  {
    question: "Can I track my referrals and earnings?",
    answer:
      "Yes, you can monitor your referrals, commissions, and performance through your IB dashboard.",
  },
  {
    question: "Can I refer clients from different countries?",
    answer:
      "Yes, IBs can generally refer clients globally, subject to platform policies and regional regulations.",
  },
  {
    question: "How are IB commissions paid?",
    answer:
      "Commissions are usually credited directly to your account and can be withdrawn according to the platform’s withdrawal policies.",
  },
];

const IntroducingBrokerfaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
      <>
        <Helmet>
             <link rel="canonical" href="https://www.hcfinvest.com/introducingBrokerfaq" />
        </Helmet>
              <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
        <ScrollToTopButton/>
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/HelpCenterImages/Newhedgecapitalsimage_Helpcenter 1.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h1
          // variant="h3"
          // component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Introducing Broker
        </h1>

      </Box>

      <Typography
        variant="h2"
        sx={{
          marginBottom: "50px",
          fontWeight: "600",
          fontSize: "2.5rem",
          color: "#101828",
        }}
      >
        FAQ
      </Typography>

      <Box sx={{ maxWidth: "1200px", margin: "40px auto" }}>
        {faqs.map((faq, index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleToggle(index)}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {faq.question}
                </Typography>
                <IconButton>
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </IconButton>
              </Box>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 2,
                    color: "text.secondary",
                    lineHeight: 1.7,
                    textAlign: "left",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
      </>
  );
};

export default IntroducingBrokerfaq;
